import { isNumber } from 'lodash'

/**
 * 数値を桁数に合うようにゼロパディングします。
 *
 * @param {number} num 数値
 * @param {number=2} length 桁数
 * @returns {string} ゼロパディングされた文字列
 */
export function padZero(num, length = 2) {
  return isNumber(num) ? String(num).padStart(length, '0') : num
}
